// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2i4Pf","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__S9nyc"};